import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {
    getActiveIndex,
    getActiveIndexText,
    getMaxIndex, selectDataTableByIndex,
    selectDataTableByType
} from "@/helpers/datatable-filter-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper.js";
import {loadLinkedDataByBreadCrumbKey} from "@/helpers/layer/info/layer-info-info-linked-data-helper.js";
import {getBySelector} from "@/helpers/element-helper.js";

export class LayerInfoInfoItemInfoNavigationComponent extends HTMLElement {
    constructor(){
        super();

            const dataTable = window.ShowMultipleRecordsInTable

            if(!dataTable) {
                return
            }

            const maxIndex = dataTable.rows().count()
            let activeIndex = dataTable.row({ selected: true }).index();
            let activeIndexText = dataTable.row({ selected: true }).index();

            const template = document.createElement('template');

            template.innerHTML =
                `<div class="ml-3 mr-3 pl-2 pt-2 pb-1 pr-2">
            <div class="row">
                <div class="col-1 pl-0">
                    <button data-type="previous" class="btn btn-sm btn-outline-secondary icon-btn">
                        <span class="fa fa-angle-left"></span>
                    </button>
                </div>
                <div class="col-4 pl-0 text-center">
                    <div style="margin-top:3px !important">
                        ` + (activeIndexText + 1) + ` / <span id="spnKVDatatableTotalIndex">` + maxIndex + `</span>
                    </div>
                </div>
                <div class="col-1 pl-0">
                    <button data-type="next" class="btn btn-sm btn-outline-secondary icon-btn float-right">
                        <span class="fa fa-angle-right"></span>
                    </button>
                </div>
                <div class="col-6">
                    <button id="btnShowFilterLayerResult" class="btn btn-outline-secondary btn-sm borderless float-right">
                        <span class="fa fa-chevron-left"></span> Info resultaat
                    </button>
                </div>
            </div>
        </div>`

        initWebComponent(this, template)

        this.addEventListener('click', (element) => {
            let type = element.target.dataset.type
            if (type === undefined) {
                type = element.target.parentElement.dataset.type
            }

            if (type !== undefined) {
                switch (type) {
                    case 'first':
                        activeIndex = 1
                        break;
                    case 'next':
                        activeIndex++
                        activeIndexText++
                        if(activeIndex === maxIndex) {
                            activeIndex = 0
                            activeIndexText = 0
                        }
                        break;
                    case 'previous':
                        if(activeIndex === 0) {
                            activeIndex = maxIndex - 1
                            activeIndexText = maxIndex - 1
                        } else {
                            activeIndex--
                            activeIndexText--
                        }
                        break;
                    case 'last':
                        activeIndex = maxIndex - 1
                        break;
                }

                window.breadCrumbs[0].pop()
                dataTable.row(activeIndex).select();
            }

            if(element.target.id=== 'btnShowFilterLayerResult') {
                getBySelector('layer-info-info-bread-crumb').click()
            }
        })
    }
}

